import request from "@/utils/request";

//公司列表
export function getImgListApi(data) {
  return request({
    url: `/fmsapi/common/GetImgAllList`,
    method: "post",
    data,
  });
};
